import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "SearchHeader" })
export default class SearchHeader extends Vue {
    public localizer: any = Localizer;
    public isQueryActive: boolean = false;
    public selectedSection: string = null;
    public debounceTimer: any = null;
    public searchtext: string = null;
    public suggestions: any[] = [];

    get userContext() {
        return this.$store.getters["accountUserStore/userContext"];
    }

    get sections(): any {
        return this.$store.getters["myFileSharingStore/sections"];
    }

    get isFilterVisible(): boolean {
        return this.$store.getters["myFileSharingStore/isFilterVisible"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("$route") onRouteChanged(value: any, oldValue: any) {
        this.selectedSection = this.$route.params.sectionName;
        this.searchtext = null;
        this.suggestions = [];
        this.checkQueryActive();
    }

    public async created() {
        this.selectedSection = this.$route.params.sectionName;
        this.checkQueryActive();
    }

    public checkQueryActive() {
        const { category, type, tags, language, dateStart, dateEnd } = this.$route.query;

        if (category || type || tags || language || dateStart || dateEnd) {
            this.isQueryActive = true;
        } else {
            this.isQueryActive = false;
        }
    }

    public setFilterVisible() {
        this.$store.commit("myFileSharingStore/setFilterVisible", !this.isFilterVisible);
    }

    public editSection(sectionIdMaster: string) {
        this.$store.commit("myFileSharingStore/setSectionEditVisible", true);
        this.$store.commit("myFileSharingStore/setSectionIdMaster", sectionIdMaster);
    }

    public uploadDocuments(sectionIdMaster: string) {
        this.$store.commit("myFileSharingStore/setSectionIdMaster", sectionIdMaster);
        this.$store.commit("myFileSharingStore/setUploadDocumentVisible", true);
    }

    public getSearchDocuments() {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(async () => {
            if (this.searchtext == null || this.searchtext.length < 3) {
                this.suggestions = [];
                return;
            }
            const result = (await Axios.post(this.routes.MyBremboPartsFileSharing_GetSearchDocuments, { searchText: this.searchtext, sectionName: this.selectedSection })).data;
            this.suggestions = result;
        }, 500);
    }

    public async deleteSection(sectionIdMaster: string) {
        if (confirm(this.localizer.get("App.FileSharing.DeleteSectionConfrim")) == true) {
            try {
                await Axios.post(this.routes.MyBremboPartsFileSharingManagement_RemoveSection, { sectionIdMaster: sectionIdMaster });

                window.location.href = this.routes.MyBremboPartsFileSharing_DocumentList;
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.$store.dispatch("bremboToastStore/onAddToast", { message: FormHelper.getValidationErrors(error.response.data)[0].message, type: "Error" });
                }
            }
        }
    }

    public removeSection() {
        this.$router.push({ name: 'SectionList' }).catch(() => { });
    }

    public goToSectionDetail(sectionName: string) {
        this.$router.push({ name: 'SectionDetail', params: { sectionName: sectionName } }).catch(() => { });
    }
}